import CustomCard from "components/Atoms/CustomCard"
import React from "react"
import DCList from "./table/dc-list/DCList"
import TableHeader from "./table/dc-list/TableHeader"

const StockSummaryDcTable = () => {
  return (
    <div className="p-3">
      <CustomCard className="vt-dispatch-table-view p-0">
        <TableHeader />
        <DCList />
      </CustomCard>
    </div>
  )
}

export default StockSummaryDcTable
